import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useAemConfig } from '@as-react/common-components';
import { ProductImageSizesPortraitEnum } from '@as-react/common-types';
import { Box, Link, LinkVariant, Text, TextSize, TextColor, GroupAlign, GroupGutter, Group, GroupVerticalAlign, ProductTile, } from '@as/cotopaxi';
import { getImageSourceSetByProductCode } from '../../util/ImageUtil';
import { getProductDetailUrl } from '../../util/ProductUtil';
import { usePriceProps } from '../../hooks/usePriceProps';
import { Price } from '@yonderland/andes-react';
const IMAGE_WIDTH = 72;
export const ProductTopFiveTile = ({ product, ranking }) => {
    var _a, _b;
    const { productImageConfig, root, feature_toggles: { lowest_price_all }, } = useAemConfig();
    const activeColour = product.colours.find(colour => colour.colourId === product.colourId);
    const productUrl = getProductDetailUrl(product, root);
    const priceProps = usePriceProps({
        priceInformation: {
            prices: activeColour.prices,
            hasDiscount: activeColour.hasDiscount,
        },
        enablePriceReference: lowest_price_all,
    });
    const productContext = {
        productCode: product.productCode,
        productId: product.productId,
        activeColorId: product.colourId,
        brand: product.brand,
        title: product.title,
        image: getImageSourceSetByProductCode(product.productCode, activeColour.image, productImageConfig)[ProductImageSizesPortraitEnum.bundles],
        review: { score: (_a = product.productRating) !== null && _a !== void 0 ? _a : 0, amount: (_b = product.productReviews) !== null && _b !== void 0 ? _b : 0 },
    };
    const [width, height] = ProductImageSizesPortraitEnum.bundles.split('x').map(Number);
    return (_jsxs(ProductTile, { variant: "horizontal", product: productContext, children: [_jsx(ProductTile.Area, { area: "primary", children: _jsx(Link, { href: productUrl, variant: LinkVariant.CONTAINER, children: _jsx(ProductTile.Image, { width: width, height: height, containerOptions: {
                            mobile: {
                                spacing: { marginRight: 1.5 },
                                width: IMAGE_WIDTH,
                            },
                        } }) }) }), _jsx(ProductTile.Area, { area: "secondary", children: _jsxs(Group, { fullHeight: true, gutter: GroupGutter.NONE, inline: true, children: [_jsx(Box, { flex: { grow: 1 }, children: _jsxs(Group, { column: true, align: GroupAlign.SPACE_BETWEEN, fullHeight: true, children: [_jsxs(Group, { column: true, gutter: { mobile: 1 }, children: [_jsx(Link, { href: productUrl, variant: LinkVariant.SUBTLE, dataQA: "product_title", children: _jsx(ProductTile.Title, { size: TextSize.SMALL }) }), _jsx(ProductTile.Rating, { amountSize: TextSize.XSMALL, amountColor: TextColor.SUBTLE })] }), !!priceProps && _jsx(Price, Object.assign({}, priceProps))] }) }), _jsx(Box, { flex: { shrink: 0 }, children: _jsx(Group, { fullHeight: true, valign: GroupVerticalAlign.BOTTOM, children: _jsx(Text, { emphasized: true, color: TextColor.SUBTLE, size: TextSize.XLARGE, children: ranking }) }) })] }) })] }));
};
